module.exports = __webpack_public_path__ + "img/16.7a6d81f9.png";